export class DisableAuthorizationInput {
  id: number;
  isEnabled: boolean;

  constructor(id: number, isEnabled: boolean) {
    this.id = id;
    this.isEnabled = isEnabled;
  }
}
